import { SET_INTERACTION_STATUS } from '../constants/InteractionConstants';

const initialState = {
  // 是否有打断/暂停监听的操作,
  justInteraction: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_INTERACTION_STATUS: {
      return {
        ...state,
        justInteraction: action.payload,
      };
    }

    default:
      return state;
  }
}
